import { Module } from 'vuex';

import { NodeTree } from '@/interfaces/site-tree.types';
import { Site } from '@/interfaces/common';

export interface AnalysesData {
    workOrderType: boolean;
    standards: boolean;
    analysisRequestTemplates: boolean;
    controlChart: boolean;
}
export interface OthersData {
    graphics: boolean;
    alerts: boolean;
}

export interface CopySiteState {
    site: Site | null;
    tree: NodeTree | null;
    analyses: AnalysesData;
    others: OthersData;
}

const defaultState: CopySiteState = {
    site: null,
    tree: null,
    analyses: {
        workOrderType: true,
        standards: true,
        analysisRequestTemplates: true,
        controlChart: true,
    },
    others: {
        graphics: true,
        alerts: true,
    },
};

const copySite: Module<CopySiteState, unknown> = {
    namespaced: true,
    state: defaultState,
    mutations: {
        setSelectedSite(state, site: Site) {
            state.site = site;
        },
        setSelectedTree(state, tree: NodeTree) {
            state.tree = tree;
        },
        setSelectedAnalysis(state, analyses: AnalysesData) {
            state.analyses = analyses;
        },
        setSelectedOthers(state, others: OthersData) {
            state.others = others;
        },
        setInitialValues(state) {
            Object.assign(state, defaultState);
        },
    },
    actions: {
        changeSelectedSite({ commit }, site: string) {
            commit('setSelectedSite', site);
        },
        changeSelectedTree({ commit }, tree: NodeTree) {
            commit('setSelectedTree', tree);
        },
        changeSelectedAnalysis({ commit }, analyses: AnalysesData) {
            commit('setSelectedAnalysis', analyses);
        },
        changeSelectedOthers({ commit }, others: OthersData) {
            commit('setSelectedOthers', others);
        },
        reset({ commit }) {
            commit('setInitialValues');
        },
    },
    getters: {
        selectedSite: (state) => state.site,
        selectedTree: (state) => state.tree,
        selectedAnalysis: (state) => state.analyses,
        selectedOthers: (state) => state.others,
    },
};

export default copySite;
